import { getFinancialProfile } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { TAX_ENTITY_TYPES } from '@/features/taxes/taxConstants'
import { TextColors, TypographyStyles } from '@/styles'
import { Image, List, Text } from '@/ui'
import { HeardListItem } from '../about-you/WhatYouGetCard'

export const OptInAndSaveCard = () => {
  const fp = useReselector(getFinancialProfile)
  const isSCorp = fp?.taxEntityType === TAX_ENTITY_TYPES.form_1120_s

  return (
    <div id="optInAndSave">
      <div className="flex justify-center bg-blue-0 rounded-tl-2xl rounded-tr-2xl">
        <Image
          src="https://heard-images.s3.us-west-1.amazonaws.com/assets/piggy_bank_pink.svg"
          alt="piggy bank"
          width={135}
          className="m-8"
        />
      </div>

      <div className="p-8 bg-neutral-25 rounded-bl-2xl rounded-br-2xl">
        <div className="flex flex-col space-y-4">
          <Text variant={TypographyStyles.H2} color={TextColors.HEADER}>
            Opt into taxes and save
          </Text>

          <Text
            variant={TypographyStyles.BODY_SM}
            className="min-h-fit text-neutral-600"
          >
            Unlock savings when you do your taxes with Heard.
          </Text>

          <List className="space-y-4 pl-0">
            <HeardListItem contentText="Up to 50% off catch up bookkeeping" />

            {isSCorp && (
              <HeardListItem
                contentText="6 months of payroll for free"
                subtext="When you sign-up for an Annual Plan"
                subtextVariant={TypographyStyles.BODY_XS}
              />
            )}

            <HeardListItem
              contentText="50% off 1:1 live tax consult"
              subtext="When you sign-up for an Annual Plan"
              subtextVariant={TypographyStyles.BODY_XS}
            />

            <HeardListItem contentText="Unlimited state tax return filings" />
          </List>
        </div>
      </div>
    </div>
  )
}
